import React, { useState, useEffect } from 'react';
import { Zap } from 'lucide-react';
import { Toggle } from '../UI/Toggle';
import { FanMode, fanModePresets } from '../../utils/automation';
import { storage } from '../../utils/storage';

export const AutomationSettings: React.FC = () => {
  const [automationEnabled, setAutomationEnabled] = useState(() => {
    const saved = storage.loadAutomationConfig();
    return saved?.enabled ?? false;
  });
  const [fanMode, setFanMode] = useState<FanMode>(() => {
    const saved = storage.loadAutomationConfig();
    return (saved?.mode as FanMode) ?? 'hot';
  });

  // Save to localStorage when settings change
  useEffect(() => {
    storage.saveAutomationConfig({ enabled: automationEnabled, mode: fanMode });
  }, [automationEnabled, fanMode]);

  return (
    <div className="space-y-6">
      <div className="glass-card p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <Zap size={20} className="text-ios-orange" />
            <span className="font-semibold">Auto Fan Control</span>
          </div>
          <Toggle
            checked={automationEnabled}
            onChange={setAutomationEnabled}
          />
        </div>

        {automationEnabled && (
          <div className="space-y-4 pt-4 border-t border-white/10">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Fan Activation Mode
              </label>
              <select
                value={fanMode}
                onChange={(e) => setFanMode(e.target.value as FanMode)}
                className="w-full glass-card px-4 py-3 rounded-lg border border-white/10 focus:border-ios-blue focus:outline-none focus:ring-2 focus:ring-ios-blue/20 transition-all"
              >
                <option value="very_hot">🌡️ Turn ON when Very HOT</option>
                <option value="hot">🌡️ Turn ON when HOT</option>
                <option value="always_on">⚡ Always ON</option>
              </select>
              <p className="text-xs text-gray-400 mt-2">
                {fanModePresets[fanMode].description}
              </p>
            </div>

            <div className="glass-card p-4 bg-black/20">
              <div className="text-sm space-y-2">
                <div>
                  <strong className="text-gray-300">Current Settings:</strong>
                </div>
                <div className="text-gray-400">
                  <div>🌡️ <strong>Temperature:</strong> ON: &gt; 28°C, OFF: &lt; 26°C</div>
                  <div>💧 <strong>Humidity:</strong> ON: &gt; 70%, OFF: &lt; 65%</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

